import { REPLACE_COUNTRIES, CLEAR_COUNTRIES } from './actions';

const initialState = {
    countries: [],
}

export default function main (state = initialState, action) {
    switch (action.type) {
        case REPLACE_COUNTRIES:
            return {
                ...state,
                countries: action.countries,
            }
        case CLEAR_COUNTRIES:
            return initialState;
        default:
            return state;
    }
}